import React, { useRef } from 'react';
import classNames from 'classnames';
import { Toggle } from '../../Objects/Toggle/Toggle';
import uuidv4 from '../../utils/uuidv4';
/**
 * Bronson ShowMore component.
 * ShowMore is an accessible content-reveal component. It consists of
 * a content body and a button that is displayed below. The internal state
 * is handled via the {@link Toggle} object.
 * @see https://bronson.vwfs.tools/default/components/detail/bronson-show-more.html
 * @constructor
 */
export function ShowMore({ children, className, defaultExpanded = false, labelCollapse, labelExpand, onChange, testId, ...otherProps }) {
    const ref = useRef(null);
    const classNameList = classNames('c-show-more', className).trim();
    const buttonId = uuidv4();
    const targetId = uuidv4();
    return (React.createElement("div", { className: classNameList },
        React.createElement("div", { className: "c-show-more__body", id: targetId, "data-testid": testId, ref: ref, ...otherProps }, children),
        React.createElement(Toggle, { className: "c-show-more__button", iconClassName: "c-show-more__icon", id: buttonId, targetId: targetId, 
            /**
             * The {@link Toggle} object takes the invert state.
             */
            defaultHidden: !defaultExpanded, labelHidden: labelExpand, labelUnhidden: labelCollapse, targetRef: ref, 
            /**
             * Pass in {@link Button.propTypes}.
             */
            iconViaCss: true, link: true, round: true, secondary: true, small: true, 
            /**
             * Register `onChange` callback.
             */
            onClick: onChange })));
}
